import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneInputFIO.styl';

/**
 * @event onEnter {value:string, dadataItem} при нажатии на enter
 * @event onInput {value:string, dadata}
 * @event onFocus {}
 * @event onBlur {}
 */
Vue.component('BXmakerAuthuserphoneInputFIO',
    {

        props: {
            title: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: () => {
                    return Math.random().toString(16).substring(2, 8) + '_' + (new Date).getTime();
                }
            },
            dadata: {
                type: String,
                default: ''
            },

        },
        data: function () {
            return {
                inFocus: false, // в фокусе поле
                isHover: false, // наведен курсор
                placeholder: '', //плейсхолдер при наведении
                isSet: false, // устанавливалось первоначальное значение
                optionActive: -1,
                needPopop: false, // нужно ли показывать попап окно
                query: this.value,
                list: [],
                delay: 300,
            };
        },
        beforeDestroy() {
            BX.removeCustomEvent('onAjaxSuccess', this.onAjaxSuccess);
        },
        mounted() {
            BX.addCustomEvent('onAjaxSuccess', BX.proxy(this.onAjaxSuccess, this));
        },
        computed: {
            classes() {
                let ar = [];

                if (this.inFocus || this.query.length > 0) {
                    ar.push('bxmaker-authuserphone-input-fio--focus');
                }
                if (this.isHover) {
                    ar.push('bxmaker-authuserphone-input-fio--hover');
                }
                if (this.needPopop) {
                    ar.push('bxmaker-authuserphone-input-fio--options');
                }

                return ar;
            },


        },
        methods: {
            onFocus() {
                this.inFocus = true;
                this.$emit('onFocus');
            },
            onBlur() {
                this.$emit('onBlur');
                this.inFocus = false;
                },
            onKeydown(e) {
                switch (e.keyCode) {
                    case 13://enter
                    {
                        if (this.list.length && this.optionActive >= 0 && this.optionActive < this.list.length) {
                            this.selectItemIndex(this.optionActive);
                            return;
                        }

                        this.$emit('onEnter', this.query);

                        return;
                    }
                    case 38://up
                    {
                        if (!this.list.length) return;

                        if (this.optionActive - 1 >= 0) {
                            this.optionActive -= 1;
                        } else if (this.optionActive === 0) {
                            this.optionActive = (this.list.length - 1);
                        }
                        return;
                    }
                    case 40://down
                    {
                        if (!this.list.length) return;
                        if (this.optionActive + 1 <= this.list.length) {
                            this.optionActive += 1;
                        } else if (this.optionActive + 1 > this.list.length) {
                            this.optionActive = 0;
                        }
                        return;
                    }
                    case 32: //space
                    {
                        if (this.list.length && this.optionActive >= 0 && this.optionActive < this.list.length) {
                            this.selectItemIndex(this.optionActive);
                            return;
                        }

                    }
                }
            },

            onMouseenter() {
                this.isHover = true;
            },
            onMouseleave() {
                this.isHover = false;
            },
            // активация фокуса на поле
            focus() {
                this.$refs.input.focus();
            },
            onInput(e) {
                this.query = e.target.value;

                if (this.dadata) {
                    this.onChangeQuery(e.target.value);
                } else {
                    this.$emit('onInput', this.query);
                }
            },
            onChangeQuery(query) {
                if (this.timer) clearTimeout(this.timer);
                if (query.length <= 0) {
                    this.needPopop = false;
                    this.list = [];
                    return;
                }
                this.timer = setTimeout(() => {
                    this.request(query);
                }, this.delay);
            },

            request(query) {

                this.resetSelection();

                /**
                 * @var r XMLHttpRequest
                 */
                let r = BX.ajax({
                    url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio',
                    method: 'POST',
                    dataType: 'json',
                    async: true,
                    processData: true,
                    preparePost: false,
                    scriptsRunFirst: true,
                    start: false,
                    cache: false,
                    onsuccess: (data) => {
                        if (data.suggestions) {
                            this.list = data.suggestions;
                            this.needPopop = true;
                        } else {
                            this.list = [];
                            this.needPopop = false;
                        }
                    },
                    onfailure: (data) => {
                        console.error('BXmaker.Authuserphone Dadata response:', data);
                    }
                });
                r.setRequestHeader('Content-Type', 'application/json');
                r.setRequestHeader('Accept', 'application/json');
                r.setRequestHeader('Authorization', 'Token ' + this.dadata);
                r.send(JSON.stringify({query: query}))
            },

            selectItemIndex(index) {
                this.resetSelection();

                if (!this.list[index]) {
                    this.needPopop = false;
                    return;
                }
                let item = this.list[index];
                this.query = item.value;

                this.$emit('onEnter', item.value, item);

                if(!item.data.name || !item.data.surname || !item.data.patronymic)
                {
                    this.$refs.input.focus();
                }

                this.needPopop = false;
            },

            resetSelection() {
                this.optionActive = -1;
            }

        },
        watch: {
            isHover(val) {
                if (val && this.isInit) {
                    this.placeholder = '';
                } else {
                    this.placeholder = '';
                }
            },
            inFocus(val) {
                if (val && !this.isSet && this.isInit) {
                    this.isSet = true;

                }
            }

        },
        //language=Vue
        template: `
          <div class="bxmaker-authuserphone-input-fio "
               :class="classes"
               @mouseenter="onMouseenter"
               @mouseleave="onMouseleave"
          >
          <div class="bxmaker-authuserphone-input-fio__field">

            <div class="bxmaker-authuserphone-input-fio__input">
              <input
                  type="text"
                  :name="name"
                  @focus="onFocus"
                  @blur="onBlur"
                  @keydown="onKeydown"
                  @input="onInput"
                  :value="query"
                  autocomplete="new-password"
                  ref="input"
                  key="fio"
                  :placeholder="placeholder"
              >
              <span class="bxmaker-authuserphone-input-fio__title">{{title}}</span>
            </div>


          </div>
          <div class="bxmaker-authuserphone-input-fio__popup">
            <div v-for="(item, index) in list"
                 :key="index + item.value"
                 :data-index="index"
                 class="bxmaker-authuserphone-input-fio__option"
                 :class="{ 'bxmaker-authuserphone-input-fio__option--selection' : +optionActive === +index}"
                 @click.stop="selectItemIndex(index)"
            >
              <span>{{item.value}}</span>
            </div>
          </div>
          </div>
        `,
    });